import { EventMetadata } from '~analytics/EventMetadata';
import { EventTypes } from '~analytics/types';

export const generateReportEventMetadata: EventMetadata = {
  name: EventTypes.GenerateReport,
  description:
    'A teacher exported an activity report (download, email, or save to drive).',
  category: 'Reports',
  platform: 'client',
  status: 'active',
  properties: {
    report_type: {
      type: 'enum',
      values: [
        'complete_results',
        'individual_students',
        'results_summary',
        'answer_key',
      ],
      description: 'Which report template was generated.',
      required: true,
    },
    delivery_method: {
      type: 'enum',
      values: ['email', 'email_to_students', 'save_to_drive', 'download'],
      description: 'How the teacher chose to receive the report.',
      required: true,
    },
    option_omit_mc_answer_content: {
      type: 'boolean',
      description:
        'Report option: omit multiple-choice answer text from the output.',
      required: true,
    },
    option_include_explanations: {
      type: 'boolean',
      description: 'Report option: include per-question explanations.',
      required: true,
    },
    option_include_correct_answers: {
      type: 'boolean',
      description:
        'Report option: include the correct answer for each question.',
      required: true,
    },
    activity_student_count: {
      type: 'number',
      description: 'Number of students represented in the activity.',
      required: true,
    },
    activity_question_count: {
      type: 'number',
      description: 'Number of questions in the source quiz.',
      required: true,
    },
    activity_type: {
      type: 'string',
      description:
        'Activity type (quiz, space race, exit ticket, quick question, …).',
      required: true,
    },
    activity_room_type: {
      type: 'enum',
      values: ['rostered_room', 'open_room'],
      description: 'Room type the activity ran in.',
      required: true,
    },
  },
};
